// extracted by mini-css-extract-plugin
export default {"reward":"_2VNn9"};